import { Outlet } from 'react-router-dom';
import { FronteggProvider, FronteggThemeOptions, useAuth } from '@frontegg/react';
import AuthService from './services/auth.service';

const authService = AuthService.getInstance();

const contextOptions = {
  baseUrl: authService.authUrl,
  clientId: authService.feClientId,
  appId: authService.feAppId,
};

const authOptions = {
  keepSessionAlive: true,
  routes: {
    loginUrl: (authService.useExternalLogin || authService.isCustomDomain) ? '/ext-login' : '/login',
    logoutUrl: '/do/logout',
    authenticatedUrl: '/',
  },
};

const themeOptions: FronteggThemeOptions = {
  loginBox: {},
};

// Wrapper component that uses useAuth hook inside FronteggProvider context
function AppContent() {
  const { isLoading, isAuthenticated } = useAuth();

  // If this app is configured for external login (local dev), redirect
  // authenticated users to the legacy app immediately before rendering any UI
  if (authService.useExternalLogin && isAuthenticated) {
    window.location.href = authService.authAppUrl;
    return null;
  }

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="text-gray-500">Loading...</div>
      </div>
    );
  }

  return <Outlet />;
}

function App() {
  return (
    <FronteggProvider
      authOptions={authOptions}
      contextOptions={contextOptions}
      themeOptions={themeOptions}
      hostedLoginBox={false}
      entitlementsOptions={{ enabled: true }}
    >
      <AppContent />
    </FronteggProvider>
  );
}

export default App;
